import React from "react";
import { Box, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "../i18n-config";
import theme from "../theme/theme";
import { capitalizeFirstLetter } from "../utils/strings";
import "./sidebar-menu.css";
import { Circle } from "@mui/icons-material";

interface Props {
  item?: any;
  parentTextStyle?: React.CSSProperties;
  closeDrawer?(): void;
  rootStyle?: React.CSSProperties;
}

const SidebarMenu = ({
  item,
  parentTextStyle,
  closeDrawer,
  rootStyle,
}: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: any) => location.pathname?.startsWith(path);

  const onNavigate = (route: string) => {
    if (route === "/support") {
      navigate("/settings/support");
    } else {
      navigate(route);
    }
    // isTablet && closeDrawer();
  };

  // return (
  //   <div className="logo-container">
  //     <div className="first"></div>
  //     <div className="second">
  //       <div>
  //       <ListItem
  //       onClick={() => onNavigate(item.path)}
  //       style={{
  //         // width: "100%",
  //         // alignItems: "center",
  //         position: "absolute",
  //         backgroundColor: theme.colors.primary,
  //         ...rootStyle,
  //       }}
  //     >
  //       <ListItemIcon sx={{ minWidth: 26, marginRight: 1 }}>
  //         {isActive(item.path) ? item.activeIcon : item.icon}
  //       </ListItemIcon>
  //       <ListItemText
  //         style={{
  //           // color: isActive(item.path)
  //           //   ? theme.colors.primary
  //           //   : theme.colors.white,
  //           fontWeight: isActive(item.path) ? "bold" : "unset",
  //           // ...(!isActive(item.path) && parentTextStyle),
  //         }}
  //         primary={capitalizeFirstLetter(i18n.t(item.name))}
  //       />
  //       {isActive(item.path) ? (
  //         <ListItemIcon sx={{ minWidth: 26, }}>
  //           <Circle htmlColor={theme.colors.secondary} sx={{width: 7, height: 7}} />
  //         </ListItemIcon>
  //       ) : null}
  //     </ListItem>
  //       </div>
  //     </div>
  //     <div className="third"></div>
  //   </div>
  // );

  return (
    <Box
      sx={{
        backgroundColor: isActive(item.path)
          ? theme.colors.white
          : theme.colors.primary,
      }}
    >
      <Box
        sx={{
          height: "1rem",
          borderBottomRightRadius: isActive(item.path) ? 100 : 0,
          backgroundColor: theme.colors.primary,
          display: isActive(item.path) ? "bloc" : "none",
        }}
      ></Box>
      <Box
        sx={{
          bgcolor: theme.colors.primary,
          paddingLeft: "1rem",
        }}
      >
        <ListItem
          onClick={() => onNavigate(item.path)}
          style={{
            backgroundColor: isActive(item.path)
              ? theme.colors.white
              : theme.colors.primary,
            width: "100%",
            alignItems: "center",
            borderTopLeftRadius: 100,
            borderBottomLeftRadius: 100,
            cursor: "pointer",
            // ...rootStyle,
          }}
        >
          <ListItemIcon sx={{ minWidth: 26, marginRight: 1 }}>
            {isActive(item.path) ? item.activeIcon : item.icon}
          </ListItemIcon>
          <ListItemText
            style={{
              color: isActive(item.path)
                ? theme.colors.primary
                : theme.colors.white,
              fontWeight: isActive(item.path) ? "bold" : "unset",
              // ...(!isActive(item.path) && parentTextStyle),
            }}
            primary={capitalizeFirstLetter(i18n.t(item.name))}
          />
          {isActive(item.path) ? (
            <ListItemIcon sx={{ minWidth: 26 }}>
              <Circle
                htmlColor={theme.colors.secondary}
                sx={{ width: 7, height: 7, position: 'absolute', right: 10 }}
              />
            </ListItemIcon>
          ) : null}
        </ListItem>
      </Box>
      <Box
        sx={{
          height: "1rem",
          display: isActive(item.path) ? "bloc" : "none",
          borderTopRightRadius: isActive(item.path) ? 100 : 0,
          backgroundColor: theme.colors.primary,
        }}
      ></Box>
    </Box>
  );
};

export default SidebarMenu;
